import React from "react";

// create context pour envoyer la data
const FirebaseContext = React.createContext(null);

// Provider = envoyer la date
// FirebaseContext.Provider

// Consumer = consumer la data 
// FirebaseContext.Consumer


export default FirebaseContext;
